import { PrivacySettingToggles } from '@prisjakt/web-app-config/markets/types';

const acceptCookies = (
  version: string,
  privacySettings?: PrivacySettingToggles,
  isLoggedIn?: boolean
) =>
  ({
    type: 'ACCEPT_COOKIES',
    version,
    privacySettings,
    isLoggedIn,
  } as const);

export default acceptCookies;
